import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_425_2961",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_425_2961)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.44425 32.2222H15.2776V23.3333C15.2776 22.9398 15.4107 22.6099 15.6769 22.3438C15.9431 22.0776 16.273 21.9445 16.6665 21.9445H23.3332C23.7267 21.9445 24.0566 22.0776 24.3228 22.3438C24.5889 22.6099 24.722 22.9398 24.722 23.3333V32.2222H30.5554V16.3889L19.9998 8.47221L9.44425 16.3889V32.2222ZM6.6665 32.2222V16.3889C6.6665 15.9491 6.76488 15.5324 6.96163 15.1389C7.15841 14.7454 7.43041 14.4213 7.77763 14.1667L18.3332 6.25C18.818 5.87964 19.372 5.69446 19.9954 5.69446C20.6187 5.69446 21.1758 5.87964 21.6665 6.25L32.222 14.1667C32.5693 14.4213 32.8413 14.7454 33.038 15.1389C33.2348 15.5324 33.3332 15.9491 33.3332 16.3889V32.2222C33.3332 32.9861 33.0612 33.6401 32.5172 34.184C31.9732 34.728 31.3193 35 30.5554 35H23.3332C22.9396 35 22.6098 34.8669 22.3436 34.6007C22.0774 34.3345 21.9443 34.0046 21.9443 33.6111V24.7222H18.0554V33.6111C18.0554 34.0046 17.9223 34.3345 17.6561 34.6007C17.3899 34.8669 17.06 35 16.6665 35H9.44425C8.68037 35 8.02643 34.728 7.48246 34.184C6.93849 33.6401 6.6665 32.9861 6.6665 32.2222Z",
			fill: "#778521"
		})
	})]
});
export default SvgHome;
